module.exports = __webpack_public_path__ + "static/media/Tree-Sifr (1).ed8a0655.png";